import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import ModalForm from "../../components/form/ModalForm";
import SatFormConfig from "../format/config/SatFormConfig";
import {Col, Row, Tab, Tabs} from "react-bootstrap";
import PartsDeletedTableConfig from "./PartsDeletedTableConfig";
import { useTranslation } from 'react-i18next';
import useFormatDeletedTableConfig from "./FormatDeletedTableConfig";

const FormatDeletedTablePage = (props) => {

    const { t } = useTranslation();
    const models = useModels();
    const [loader, setLoader] = useState(false);
    const [satDetails, setSatDetails] = useState();

    const columns = useFormatDeletedTableConfig();

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("menu.formats_withdrawn")}
                             
                             parent={
                                 <LinkIconButton
                                     model={models.formatDeleted}
                                     props={props}
                                 />
                             }
            >
                <Col>
                    <div>
                        <Tabs id="deletedFormats">

                            <Tab eventKey="formats" title={t("menu.formats")}>
                                <CardTable
                                    className={"mt-4"}
                                    title={t("common.formats_list")}
                                    source={"format/status-in?statuses=WITHDRAWN"}
                                    width={12}
                                    columns={columns}
                                    setLoader={setLoader}
                                    striped={false}
                                    shadow={true}
                                />
                            </Tab>
                            <Tab eventKey="parts" title={t("forms.parts")}>
                                <Row>
                                    <CardTable
                                        className={"mt-4"}
                                        title={t("forms.parts_list_withdrawn")}
                                        source={"part/withdrawn"}
                                        width={12}
                                        readOnly={true}
                                        columns={PartsDeletedTableConfig}
                                        setLoader={setLoader}
                                        striped={false}
                                        shadow={true}
                                    />
                                </Row>
                            </Tab>


                        </Tabs>
                    </div>
                </Col>

            </CustomContainer>
            <ModalForm
                open={!!satDetails}
                setOpen={setSatDetails}
                shadow={false}
                fields={SatFormConfig}
                setLoader={props.setLoader}
                initialData={satDetails}
                readOnly={true}
                title={t("forms.sat_details")}
                size={"md"}
            />
        </>
    );
};

export default FormatDeletedTablePage;
